function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h15v7.5H0v-7.5Z",
    style: {
      fill: "#002b7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M7.5,12.706l.644,1.981-1.685-1.225h2.083l-1.685,1.225.643-1.981Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M5.208,9.688l.515,1.585-1.348-.98h1.667l-1.348.98.514-1.585Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b1",
    "data-name": "b",
    d: "M7.5,7.812l.515,1.585-1.348-.98h1.667l-1.348.98.514-1.585Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b2",
    "data-name": "b",
    d: "M9.844,9.375l.483,1.486-1.264-.919h1.562l-1.264.919.483-1.486Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M8.646,11.301l.322.991-.843-.613h1.042l-.843.613.322-.991Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWs);
export default __webpack_public_path__ + "static/media/WS.d7d772f9f80dda90225322cf33f46d4f.svg";
export { ForwardRef as ReactComponent };